import { render, staticRenderFns } from "./staffTransferHistory.vue?vue&type=template&id=b410b18a&scoped=true&"
import script from "./staffTransferHistory.vue?vue&type=script&lang=js&"
export * from "./staffTransferHistory.vue?vue&type=script&lang=js&"
import style0 from "./staffTransferHistory.vue?vue&type=style&index=0&id=b410b18a&lang=scss&scoped=true&"
import style1 from "./staffTransferHistory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b410b18a",
  null
  
)

export default component.exports